<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button v-if="selectedLastRevisionRow && currentUser.role != 'Reader'" v-show="!isEdit&&tabStatus==0&&isOwner" @click="edit"
            icon="edit" bold :text="lang.button_Edit" :tooltip="lang.button_Edit" :disabled="editButtonStatus" />
          <action-button v-if="selectedLastRevisionRow && currentUser.role != 'Reader'" v-show="isEdit&&tabStatus==0&&isOwner" @click="unedit"
            icon="edit" bold :text="lang.button_Unedit" :tooltip="lang.button_Unedit" :disabled="uneditButtonStatus" />
          <action-button v-if="selectedLastRevisionRow && currentUser.role != 'Reader'" v-show="tabStatus==0&&isOwner" @click="save" icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save" :disabled="saveButtonStatus" :save="saveStatus"/>

          <action-button v-if="currentUser.role != 'Reader'" v-show="tabStatus==0" @click="derive" icon="derive" bold :text="lang.button_Derive" :title="lang.button_Derive" :disabled="deriveButtonStatus" />
          <action-button v-if="tabStatus==0&&currentUser.role=='Admin'" @click="renaming" icon="revision" bold :text="lang.button_Renaming" :title="lang.button_Renaming" :disabled="renamingButtonStatus" />
          <action-button v-if="tabStatus==0&&currentUser.role=='Admin'" @click="transferOwnership" icon="move-to" bold :text="lang.button_TransferOwnership" :title="lang.button_TransferOwnership" :disabled="transferOwnershipButtonStatus" />

          <action-button v-show="tabStatus==0&&isOwner==true&&selectedLastRevisionRow" v-if="(isPlugin||isAgent)&& appConf.status.isBasicBundle == false" @click="checkLocalProject" icon="open" bold :text="lang.button_Open" :title="lang.button_Open"
            :disabled="openButtonStatus" />
          <action-button v-show="tabStatus==0&&isOwner==false&&delegatedResource &&selectedLastRevisionRow"
            v-if="(isPlugin||isAgent)&& appConf.status.isBasicBundle == false" @click="checkLocalProject" icon="open" bold :text="lang.button_Open" :title="lang.button_Open" :disabled="openButtonStatus" />
          <action-button v-show="tabStatus==0&&isOwner==false&&delegatedResource==false"
            v-if="(isPlugin||isAgent)&& appConf.status.isBasicBundle == false" @click="checkLocalProject" icon="open" bold :text="lang.button_Open" :title="lang.button_Open" :disabled="openButtonStatus" />
          <action-button v-show="tabStatus==0&&isOwner==true&&selectedLastRevisionRow" v-if="(isPlugin||isAgent)&& appConf.status.isBasicBundle == false" @click="push" icon="import" bold :text="lang.button_Push" :title="lang.button_Push" :disabled="pushButtonStatus" />
          <action-button v-show="tabStatus==0&&isOwner==false&&delegatedResource&&selectedLastRevisionRow" v-if="(isPlugin||isAgent)&& appConf.status.isBasicBundle == false" @click="push" icon="import" bold :text="lang.button_Push" :title="lang.button_Push" :disabled="pushButtonStatus" />


          <action-button v-if="((!isBom&&appConf.status.isBasicBundle == true)||(appConf.status.isBasicBundle == false)) && currentUser.role != 'Reader'" v-show="tabStatus==1&&isOwner" @click="importBom" icon="import" bold :text="lang.button_ImportBom" :tooltip="lang.button_ImportBom" :disabled="importBomButtonStatus" />
          <action-button v-show="tabStatus==1" @click="openBom" icon="open" bold :text="lang.button_OpenBom"
            :tooltip="lang.button_OpenBom" :disabled="openBomButtonStatus" />

          <action-button v-show="tabStatus == 1 && isOwner && bomsProjectLength==1 && selectedLastRevisionRow && currentUser.role != 'Reader'" @click="deleteBom" icon="remove" bold :text="lang.button_DeleteBom" :tooltip="lang.button_DeleteBom" :disabled="deleteCoreBomButtonStatus" />
          <action-button v-show="tabStatus == 1 && isOwner && bomsProjectLength>1 && selectedLastRevisionRow && currentUser.role != 'Reader'" @click="deleteBom" icon="remove" bold :text="lang.button_DeleteBom" :tooltip="lang.button_DeleteBom" :disabled="deleteBomButtonStatus" />

          <action-button v-if="appConf.status.isBasicBundle == false && currentUser.role != 'Reader'" v-show="tabStatus == 1 && isOwner && selectedLastRevisionRow" @click="createVariant" icon="new" bold :text="lang.button_CreateVariant"
            :tooltip="lang.button_CreateVariant" :disabled="createVariantButtonStatus" />

          <action-button v-if="appConf.status.isBasicBundle == false && currentUser.role != 'Reader'" v-show="tabStatus==0&&isOwner && selectedLastRevisionRow" @click="importIPC" icon="import" bold :text="lang.button_ImportIPC" :tooltip="lang.button_ImportIPC" :disabled="importIPCButtonStatus" />
          <action-button v-if="appConf.status.isBasicBundle == false && currentUser.role != 'Reader'" v-show="tabStatus==0&&isOwner&&!noIpcImage && selectedLastRevisionRow" @click="removeIPC" icon="remove" bold :text="lang.button_RemoveIPC" :tooltip="lang.button_RemoveIPC" :disabled="removeIPCButtonStatus" />

        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :title="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :title="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>

        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
import ActionBar from "@/components/shared/ActionBar";
import ActionButton from "@/components/shared/ActionButton";
import ActionContent from "@/components/shared/ActionContent";
import ActionPanel from "@/components/shared/ActionPanel";

import Content from "@/components/ProjectManager/Views/ProjectDetails/Middle/Content/Content";
import {mapGetters } from 'vuex'
import * as Tools from '../../../../../Tools/Tools'

export default {
  name: "Middle",
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content
  },
  props: {
    lang: Object
  },
  data() {
    return {
      saveButtonStatus: true,
      editButtonStatus: false,
      uneditButtonStatus: true,
      backButtonStatus: false,
      importBomButtonStatus: false,
      openBomButtonStatus: false,
      deleteCoreBomButtonStatus: false,
      deleteBomButtonStatus: false,
      createVariantButtonStatus: false,
      openButtonStatus: false,
      pushButtonStatus: false,
      deriveButtonStatus: false,
      renamingButtonStatus: false,
      transferOwnershipButtonStatus: false,
      importIPCButtonStatus: false,
      removeIPCButtonStatus: false,

      saving: false,
      tabStatus: 0,
      selectedRows: [],
      bomsProjectLength: 0
    };
  },
  computed: {
    ...mapGetters({
     
      isPlugin: "isPlugin",
      isAgent: "isAgent",
      currentUser: "currentUser",
      appConf: 'appConf',
    }),
    lastRevisionHistory(){
      if (this.$store.getters.revisionHistory == null){
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++){
        
        if (tab[i].revision > obj.revision){
          obj = tab[i];
        }
      }
      
      return obj;
    },
    isOwner(){
      if (this.lastRevisionHistory == undefined){
        return false;
      }
      
      
      if (this.lastRevisionHistory.userId == this.$store.getters.currentUser.userId && this.lastRevisionHistory.status.display == "pending"){
        return true;
      }
      return false;
    },
    isEdit() {
      return this.$store.getters.isEditPropertyForm;
    },
    selectedBomRow(){
      return this.$store.getters.selectedBomRow;
    },
    selectedRevisionRow(){
      return this.$store.getters.selectedRevisionRow;
    },
    selectedLastRevisionRow(){
      if (this.$store.getters.selectedRevisionRow.length == 0){
        return false;
      }
      return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
    },
    projectId() {
      return this.$store.getters.revisionHistory[0].projectId;
    },
    delegatedResource() {
      return this.$store.getters.delegatedResource;
    },
    isBom() {
      return this.$store.getters.isBom;
    },
    noIpcImage() {
      return this.$store.getters.noIpcImage
    },
    saveStatus() {
      return this.$store.getters.saveStatus;
    }
  },
  created() {},
  watch: {
    isEdit: function(newVal) {
      this.saveButtonStatus = !newVal;
      this.editButtonStatus = newVal;
      this.uneditButtonStatus = !newVal;
    },
    selectedBomRow: function(new_isData) {
      //for details button
      if (this.selectedBomRow.length == 1) {
        this.openBomButtonStatus = false;
      } else {
        this.openBomButtonStatus = true;
      }
      
      
        
      if (this.selectedBomRow.length == 1) {
        if (new_isData.length > 0) {
          if ((this.bomsProjectLength == 1) && (new_isData[0].isCore == true)) {
            
            this.deleteCoreBomButtonStatus = false;
          } else {
            
            this.deleteCoreBomButtonStatus = true;
          }
        } else {
          
          this.deleteCoreBomButtonStatus = true;
        }
      } else {
        
        this.deleteCoreBomButtonStatus = true;
      }
      
      
      if (this.selectedBomRow.length == 1) {
        if (this.bomsProjectLength > 1 && new_isData[0].isCore == false) {
          this.deleteBomButtonStatus = false;
        } else {
          this.deleteBomButtonStatus = true;
        }

      } else {
        this.deleteBomButtonStatus = true;
      }
      if (this.selectedBomRow.length == 1) {
        this.createVariantButtonStatus = false;
      } else {
        this.createVariantButtonStatus = true;
      }
      
    },
    selectedRevisionRow: function() {
      //for derive button
      if (this.selectedRevisionRow.length == 1){
        this.deriveButtonStatus = false

      }else{
         this.deriveButtonStatus = true
      }
      //for derive changeName
      if (this.selectedRevisionRow.length == 1) {
        this.renamingButtonStatus = false

      } else {
        this.renamingButtonStatus = false
      }
      //for derive changeName
      if (this.selectedRevisionRow.length == 1) {
        this.transferOwnershipButtonStatus = false

      } else {
        this.transferOwnershipButtonStatus = false
      }
    },
    selectedLastRevisionRow: function () {
      //for derive button
      if (this.selectedLastRevisionRow == true) {
        this.importBomButtonStatus = false

      } else {
        this.importBomButtonStatus = true
      }
    }


  },

  methods: {
    setBomsProjectLength(arg) {
      this.bomsProjectLength = arg;
    },
    switchButtons(index){
      
      this.tabStatus = index;
    },
    importBom() {

      let vue = this;
      function goto(to){

        

        const query = {
          from: vue.$route.path,
          to: to,
          //projectId: vue.$route.query.projectId,
          revisionId: vue.selectedRevisionRow[0].revisionId,
          id: vue.projectId,
        }

        vue.$router.push({ path: to, query: query });

      }

      if (this.isBom == true) {
        let funcYes = function (e) {

          let bomImportType = vue.$store.getters.importBomTypeForm.bomImportType;

          
          console.log("func a", bomImportType)
          
          if (bomImportType == "csv") {
            let to = "/ProjectManager/ProjectImportBom";
            goto(to);
          } else if (bomImportType == "lst") {
            let to = "/ProjectManager/ProjectImportBomLst";
            goto(to);
          }
          


        }

        const obj = {

          text: "",
          type: "import_bom_type",
          buttons: 2,
          size: "lm",
          lang: this.lang.modal_ImportBomType,
          funcNo: "",
          funcYes: funcYes
        };
        this.$store.dispatch("showModalComponent", obj);
        
      } else {
        let to = "/ProjectManager/ProjectImportBom";
        goto(to);
      }
      

      
    },
    openBom(){
      
      let to = "/ProjectManager/ProjectBom";

      
      

      const query = {
        from: this.$route.path,
        to: to,
        projectId: this.$route.query.projectId,
        revisionId: this.$route.query.revisionId,
        currentRevisionId: this.$store.getters.selectedRevisionRow[0].revisionId,
        id: this.$route.query.id
      }

      this.$router.push({ path: to, query: query });
    },
    deleteBom(){

      let vue = this;


      let deleteBomFunc = function () {
        const obj = {
          bomId: vue.$store.getters.selectedBomRow[0].bomId
        }
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteBom", obj)
          .then(function (result) {
            console.log(result)
        
              let obj = {};
              if (result.status == "OK") {

                if (result.data != null) {
                  obj = {
                    text: vue.lang.alert_success_delete_bom,
                    time: 10,
                    type: "success"
                  }

                  const reloadObj = {
                    status: true,
                    name: "BomsProjectTableComponent"
                  }
                  vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                } else {
                  obj = {
                    text: vue.lang.alert_error_delete_bom + ".",
                    time: 15,
                    type: "danger"
                  }

                }
              } else {
                obj = {
                  text: vue.lang.alert_error_delete_bom + ": " + result.message,
                  time: 15,
                  type: "danger"
                }

              }
              vue.$store.dispatch("displayFooterAlert", obj);

            
          })

      }
      

      const obj = {
        title: "Deleting",
        text: this.lang.alert_DeleteBom,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteBomFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);

    },
    edit() {
      this.$store.dispatch("editPropertiesForm", true);
    },
    unedit() {
      this.$store.dispatch("editPropertiesForm", false);
    },
    save() {
      let vue = this;

      

      let trig = false;
      for (
        let i = 0, lei = this.$store.getters.propertyToSaving.length;
        i < lei;
        i++
      ) {
        if (
          this.$store.getters.propertyToSaving[i].isRequiredOnRequest == true &&
          this.$store.getters.propertyToSaving[i].value == ""
        ) {
          trig = true;
          break;
        }
      }

      if (trig == true) {
        let obj = {
          text: this.lang.alert_error_edit_required,
          time: 10,
          type: "danger"
        };

        this.$store.dispatch("displayFooterAlert", obj);
      } else {
        let revisionId = "";
        const tab = this.$store.getters.selectedRevisionRow;
        let rev = 0;
        let revId = "";
        for (let i = 0, lei = tab.length; i < lei; i++) {
          if (tab[i].revision > rev) {
            rev = tab[i].revision;
            revId = tab[i].revisionId;
          }
        }
        revisionId = revId;

        let obj = {
          revisionId: revisionId, 
          values: this.$store.getters.propertyToSaving
        };

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateProject", obj)
          .then(function(result) {
            if (result.status == "OK") {
              if (result.data != 0) {
                revisionId = result.data;

                vue.saving = true;

                let obj = {
                  text: vue.lang.alert_success_edit_library,
                  time: 5,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);

                const reloadObj = {
                  status: true,
                  name: "ProjectRevisionHistoryComponent",
                  source: ""
                };
                vue.$store.dispatch("reloadAfterAction", reloadObj);

                vue.$store.dispatch("setSaveStatus", false);

                for (
                  let i = 0,
                    lei = vue.$store.getters.libraryFilesToSaving.length;
                  i < lei;
                  i++
                ) {
                  //let temp = vue.$store.getters.libraryFilesToSaving[i].name.split(".");

                  //let filename = temp[0];
                  //let ext = temp[temp.length - 1];

                  // if ((ext.toLowerCase() == "svg") && (filename == libraryName)){

                  //   const obj = {
                  //     revisionId: revisionId,
                  //     file: vue.$store.getters.libraryFilesToSaving[i]
                  //   }

                  //   vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_importImage", obj)
                  //   .then(function(result){

                  //     if (result.status == "OK"){
                  //       console.log(result)
                  //     }

                  //   })
                  // }else{

                  let modDate = vue.$store.getters.libraryFilesToSaving[i].lastModified;
                  //const d = new Date(modDate)
                  //                   console.log(d)
                  //                   var utcDate = d.toUTCString();
                  // console.log(utcDate)
                  const obj = {
                    revisionId: revisionId,
                    file: vue.$store.getters.libraryFilesToSaving[i],
                    lastModified: Tools.IntegerToIntegerUTC(modDate)
                  };

                  vue.$store
                    .dispatch(
                      vue.$store.getters.sectionPrefix + "_importFiles",
                      obj
                    )
                    .then(function(result) {
                      if (result.status == "OK") {
                        console.log(result);
                      }
                    });
                  //}
                }
              }
            } else {
              let message = result.message;

              let obj = {
                text: vue.lang.alert_error_edit_library + ": " + message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }
          });
      }
    },
    checkLocalProject(){
      let vue = this;
      
      this.lockedRevisionId = this.$store.getters.selectedRows[0];

      const obj = {
        //revisionId: this.lastRevisionHistory.id,
        revisionId: this.selectedRevisionRow[0].revisionId,
        
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_checkProject", obj)
      .then((result) => {
        console.log(result);
        if (result.status == "OK"){

          let files = result.data.localFiles.filter(elem => elem.depth > 1);
          let path = result.data.localPath;

          if (files.length > 0){
            let funcYes = function(){
              
              
            
              vue.open();
           
            }

            const obj = {
              title: vue.lang.alert_title_openProject,
              text: vue.lang.alert_openProject_1 + " (" + path + "). " + vue.lang.alert_openProject_2,
              type: "question",
              buttons: 2,
              size: "lm",
              funcYes: funcYes,
              funcNo: "",

            }
    
            vue.$store.dispatch("showAlert", obj);
          }else{
            vue.open();
          }
        
        }else{

          let obj = {
            text: vue.lang.alert_error_CheckProject + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }
        
      })
        

    },
    open() {
      let vue = this;

      this.$store.dispatch("showLoader", {visible: true, text: "open"});

      this.lockedRevisionId = this.$store.getters.selectedRows[0];

      const obj = {
        revisionId: this.selectedRevisionRow[0].revisionId,
        
      };
      
      this.$store
        .dispatch(this.$store.getters.sectionPrefix + "_openProject", obj)
        .then(result => {
          console.log(result);

          if (result.status == "OK") {
            let obj = {
              text: "",
              time: 10,
              type: "success"
            };

            if (result.data.pullLibraryFilesResult == null) {
              obj = {
                text: "Error",
                time: 15,
                type: "danger"
              }
              vue.$store.dispatch("displayFooterAlert", obj);
              return;
            }

            if (result.data.pullLibraryFilesResult.status == "OK") {
              obj = {
                text:
                  vue.lang.alert_success_OpenProject +
                  " " +
                  result.data.pullLibraryFilesResult.data.localPath,
                time: 10,
                type: "success"
              };
            } else {
              obj = {
                text:
                  vue.lang.alert_error_OpenProject +
                  result.data.pullLibraryFilesResult.message,
                time: 15,
                type: "danger"
              };
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          } else {
            let obj = {
              text: vue.lang.alert_error_OpenProject + ": " + result.message,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
          }
          vue.$store.dispatch("showLoader", {visible: false});
        })
        .catch((reason) => {

          console.log("Error:", reason)
          
          vue.$store.dispatch("showLoader", { visible: false });
        })
        
        
    },
    push() {
      let vue = this;
      this.$store.dispatch("showLoader", {visible: true, text: "push"});
     
      this.lockedRevisionId = this.$store.getters.selectedRows[0];

      const obj = {
        revisionId: this.lastRevisionHistory.id,
        
      };

      this.$store
        .dispatch(this.$store.getters.sectionPrefix + "_pushProject", obj)
        .then(result => {
          console.log(result);

          if (result.status == "OK") {

            
            
            // result.data.lockedRevisionId = vue.lockedRevisionId.col___revisionId.revisionId;

            let func = function() {
              

              let obj = {
                text: vue.lang.alert_success_PushProject,
                time: 10,
                type: "success"
              };

              vue.$store.dispatch("displayFooterAlert", obj);

              let reloadObj = {
                status: true,
                name: "ProjectRevisionHistoryComponent"
              };
              vue.$store.dispatch("reloadAfterAction", reloadObj);

              reloadObj = {
                status: true,
                name: "BomsProjectTableComponent"
              };
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              
            };

            const obj = {
              title: vue.lang.modal_title_PushProject,
              text: "",
              type: "push_files",
              buttons: 1,
              buttonName: "Close",
              size: "xl",
              lang: vue.lang.modal_PushProject,
              funcNo: "",
              funcYes: "",
              funcCustom: func,
              data: result.data
            };
            
            vue.$store.dispatch("showModalComponent", obj);
            
          } else {
            let obj = {
              text: vue.lang.alert_error_PushProject + ": " + result.message,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
          }
          vue.$store.dispatch("showLoader", {visible: false});
        })
        .catch((reason) => {

          console.log("Error:", reason)

          vue.$store.dispatch("showLoader", { visible: false });
        })
    },
    derive() {

      let to = "/ProjectManager/ProjectDerive";



      

      const query = {
        from: this.$route.path,
        to: to,
        revisionId: this.selectedRevisionRow[0].revisionId,
        id: this.projectId,
        source: "ProjectDetails"
      }

      this.$router.push({ path: to, query: query });

    },
    renaming() {
      
      let vue = this;

      let projectId = this.projectId;

      

      let funcYes = function (e) {

        let newProjectNumber = vue.$store.getters.newRenamingValue;

        if (newProjectNumber.NewName == null) {

          let obj = {
            text: vue.lang.alert_error_RenameProjectName,
            time: 15,
            type: "danger"
          };

          vue.$store.dispatch("displayFooterAlert", obj);
          return
        }

        let obj = {
          projectId: projectId,
          newProjectNumber: newProjectNumber.NewName
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_changeProjectNumber", obj)
          .then(function (result) {
            
            console.log(result)

            if (result.status == "OK") {
              if (result.data != null) {


                //reload table
                let reloadObj = {
                  status: true,
                  name: "ProjectRevisionHistoryComponent"
                }
                vue.$store.dispatch("reloadAfterAction", reloadObj);

                
                //reload left panel
                reloadObj = {
                  status: true,
                  name: "LeftContentProjectDetails"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                let obj = {
                  text: vue.lang.alert_success_RenameProject,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_RenameProject + ". ",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }
            } else {
              let obj = {
                text: vue.lang.alert_error_RenameProject + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }




          })

      }
      
      var obj = {

        text: "",
        type: "renaming",
        buttons: 2,
        size: "lm",
        lang: this.lang.modal_Renaming,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);

    },
    transferOwnership() {

      let vue = this;

      let funcYes = function (e) {

        let transferOwnershipForm = vue.$store.getters.transferOwnershipForm;



        let obj = {
          revisionId: vue.lastRevisionHistory.id,
          userId: transferOwnershipForm.userId
        }
        
        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_transferOfOwnership", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {



              if (result.data != null) {

                
                vue.$store.dispatch("setAuthorityToChange", true);

                let obj = {
                  text: vue.lang.alert_success_TransferOwnership,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);


                //reload table
                const reloadObj = {
                  status: true,
                  name: "ProjectRevisionHistoryComponent"
                }
                vue.$store.dispatch("reloadAfterAction", reloadObj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_TransferOwnership + ". ",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_TransferOwnership + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      var obj = {

        text: "",
        type: "transferownership",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_TransferOwnership,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);
    },
    createVariant() {

      
      let vue = this;

      

      let funcYes = function (e) {

        
        let form = vue.$store.getters.createBomVariantForm;

        if (form.name == null) {

          let obj = {
            text: vue.lang.alert_error_CreateBomVariantName,
            time: 15,
            type: "danger"
          };

          vue.$store.dispatch("displayFooterAlert", obj);
          return
        }

        let obj = {
          bomId: vue.$store.getters.selectedBomRow[0].bomId,
          name: form.name,
          description: form.description
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_createBomVariant", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {
              if (result.data != null) {


                //reload table
                const reloadObj = {
                  status: true,
                  name: "BomsProjectTableComponent"
                }
                vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                let obj = {
                  text: vue.lang.alert_success_CreateBomVariant,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_CreateBomVariant + ".",
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }
            } else {
              let obj = {
                text: vue.lang.alert_error_CreateBomVariant + ": " + result.message,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      var obj = {

        text: "",
        type: "createbomvariant",
        buttons: 2,
        size: "lm",
        lang: this.lang.modal_CreateBomVariant,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);
      
    },
    importIPC() {

      let to = "/ProjectManager/ProjectImportIPC";


      const query = {
        from: this.$route.path,
        to: to,
        revisionId: this.selectedRevisionRow[0].revisionId,
        id: this.projectId
      }

      console.log(query)

      this.$router.push({ path: to, query: query });
    },
    removeIPC() {

      let vue = this;

      let obj = {
        projectRevisionId: this.selectedRevisionRow[0].revisionId
        
      }

      vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_removeSvgFromIpc", obj)
        .then(function (result) {

          console.log(result)

          if (result.status == "OK") {
            if (result.data != null) {


              //reload table
              const reloadObj = {
                status: true,
                name: "IpcViewerComponent"
              }
              vue.$store.dispatch("reloadAfterAction", reloadObj);

              let obj = {
                text: vue.lang.alert_success_RemoveIpc,
                time: 10,
                type: "success"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            } else {
              let obj = {
                text: vue.lang.alert_error_RemoveIpc + ".",
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }
          } else {
            let obj = {
              text: vue.lang.alert_error_RemoveIpc + ": " + result.message,
              time: 15,
              type: "danger"
            };

            vue.$store.dispatch("displayFooterAlert", obj);
          }


        })
      
    },
    back() {
      this.$store.dispatch("resetPropertyToSaving");

      this.$store.dispatch("deleteAllSelectedRows");
      

      this.$store.dispatch("resetPropertyToSaving");

      //if (this.saving) {
        
        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiProjComponent"
        }
        this.$store.dispatch("reloadAfterAction", reloadObj);


      //}

      let to = "/ProjectManager/ProjectTable"//this.$route.query.from;

      
      
      if (this.$route.query.from == "/ProjectManager/ProjectDetails") {
        const goalObj = {
          type: "project",
          revisionId: this.$store.getters.goToObject.back.revisionId,
          id: this.$store.getters.goToObject.back.id,
          to: this.$store.getters.goToObject.back.path
        }

        this.goTo(goalObj);

        return
      }

      if (this.$route.query.from == "/PartManager/PartTable") {
        const goalObj = {
          type: "part",
          revisionId: this.$route.query.sourceRevisionId,
          id: this.$route.query.sourceId,
          to: this.$route.query.from,
          end: true
        }

        this.goTo(goalObj);

        return
      }

      if (this.$route.query.from == "/PartManager/PartDetails") {
        const goalObj = {
          type: "part",
          revisionId: this.$route.query.sourceRevisionId,
          id: this.$route.query.sourceId,
          to: this.$route.query.from,
          end: true
        }

        this.goTo(goalObj);

        return
      }

      if (this.$route.query.from == "/LibraryManager/LibraryTable") {
        const goalObj = {
          type: "library",
          revisionId: this.$route.query.sourceRevisionId,
          id: this.$route.query.sourceId,
          to: this.$route.query.from,
          end: true
        }

        this.goTo(goalObj);

        return
      }

      if (this.$route.query.from == "/LibraryManager/LibraryDetails") {
        const goalObj = {
          type: "library",
          revisionId: this.$route.query.sourceRevisionId,
          id: this.$route.query.sourceId,
          to: this.$route.query.from,
          end: true
        }

        this.goTo(goalObj);

        return
      }



      

      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });
    },
    goTo(goalObj) {

     
      this.$store.dispatch("projm_setSelectedBomRow", goalObj.selectedBomRow)


      let to = goalObj.to;

      let obj = {
        col___revisionId: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        },
        col___revision: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        },
        col___status: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }

        },
        col___name: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }

        },
        col___image: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        },
        col___libraryType: {
          revisionId: goalObj.revisionId,
          projectId: goalObj.id,
          value: {
            display: ""
          }
        }
      }

      if (goalObj.type == "part") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            partId: goalObj.id,
            value: {
              display: ""
            }
          }
        }
      }
      if (goalObj.type == "library") {
        obj = {
          col___revisionId: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___revision: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___name: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: ""
            }

          },
          col___image: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: ""
            }
          },
          col___libraryType: {
            revisionId: goalObj.revisionId,
            libraryId: goalObj.id,
            value: {
              display: ""
            }
          }
        }
      }

      
      
      
      

      const query = {
        from: this.$route.path,
        to: to,
        id: goalObj.id,
        revisionId: goalObj.revisionId,
        end: goalObj.end
      }

      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      this.$store.commit('DESELECTALLREVISIONROW');
      

      this.$router.push({ path: to, query: query });


    },
    toggleRightPanel() {
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
    },
    toggleLeftPanel() {
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
    }
  }
};
</script>


<style scoped>
.middle {
  border-right: 1px solid #666;
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDetails/Middle/Middle.vue